import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import icon from '../../assets/sidebar/uploadWhite.svg';
import uploadStock from '../../api/cars/uploadStock';
import clearStock from '../../api/cars/clearStock';
import alert from '../../helpers/alert';
import isFileSizeSmallerThan from '../../utils/validateFileSize';
import isUserHaveRole from '../../utils/isUserHaveRole';
import { ROLE_ADMIN } from '../../constants/roles';
import StockPendingRowsTable from './StockPendingRowsTable';
import BitrixImportPanel from './BitrixImportPanel';
import StockImportHistory from './StockImportHistory';
import styles from './stockUpload.module.css';

const ALLOWED_EXTENSIONS = ['.xlsx', '.xls'];
const MAX_FILE_SIZE_MB = 10;
const MAX_FILES = 15;

const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

const getFileExtension = (filename) => {
  const lastDot = filename.lastIndexOf('.');
  return lastDot !== -1 ? filename.substring(lastDot).toLowerCase() : '';
};

const StockUpload = () => {
  const navigate = useNavigate();
  // ÐÑÑ Ð¿Ð°ÑÐºÐ° Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ ÑÐ°Ð¹Ð»Ð¾Ð² ÑÑÐ¾Ð´Ð¸Ñ Ð¾Ð´Ð½Ð¸Ð¼ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð¼ Ð¸ Ð¾Ð±ÑÐ°Ð±Ð°ÑÑÐ²Ð°ÐµÑÑÑ Ð±ÑÐºÐ¾Ð¼ ÐºÐ°Ðº
  // Ð¾Ð´Ð¸Ð½ Ð»Ð¾Ð³Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð¸Ð¼Ð¿Ð¾ÑÑ (ÑÐ¼. uploadStock.js) â Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÑÑ Ð¸Ð¼ÐµÐ½Ð½Ð¾ ÑÐ¿Ð¸ÑÐ¾Ðº, Ð°
  // Ð½Ðµ Ð¿Ð¾ÑÐ»ÐµÐ´Ð¾Ð²Ð°ÑÐµÐ»ÑÐ½Ð°Ñ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ° Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¼Ñ ÑÐ°Ð¹Ð»Ñ
  const [files, setFiles] = useState([]);
  // ÐÑÑÐ¾ÑÐ½Ð¸Ðº ÑÑÑÐ¾Ðº â ÑÐ°Ð¹Ð»Ñ Ð¸Ð»Ð¸ ÐÐ¸ÑÑÐ¸ÐºÑ. ÐÑÑ, ÑÑÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ñ ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÐ°
  // (ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð¸ÑÐ¾Ð³Ð¾Ð², ÑÑÑÐ½Ð°Ñ Ð¿ÑÐ°Ð²ÐºÐ°, ÐºÐ¾Ð¼Ð¼Ð¸Ñ), Ñ Ð¾Ð±Ð¾Ð¸Ñ Ð¸ÑÑÐ¾ÑÐ½Ð¸ÐºÐ¾Ð² Ð¾Ð±ÑÐµÐµ
  const [source, setSource] = useState('file');
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [result, setResult] = useState(null);
  const inputRef = useRef(null);

  // ÐÑÐ¸ÑÑÐºÐ° Ð²ÑÐµÐ³Ð¾ ÑÑÐ¾ÐºÐ° â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½. ÐÐ²ÑÑÑÐ°Ð³Ð¾Ð²Ð¾Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð²Ð¼ÐµÑÑÐ¾
  // ÑÐ¸ÑÑÐµÐ¼Ð½Ð¾Ð³Ð¾ confirm: Ð¿ÐµÑÐ²ÑÐ¹ ÐºÐ»Ð¸Ðº Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð¸Ñ ÐºÐ½Ð¾Ð¿ÐºÑ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ",
  // Ð²ÑÐ¾ÑÐ¾Ð¹ â Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐµÑ. Ð¡Ð¾ÑÑÐ¾ÑÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑÑÑ ÑÐµÑÐµÐ· ÑÐ°Ð¹Ð¼Ð°ÑÑ, ÑÑÐ¾Ð±Ñ
  // Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð½Ðµ ÑÑÐ°Ð±Ð¾ÑÐ°Ð»Ð¾ ÑÐ»ÑÑÐ°Ð¹Ð½Ð¾ ÑÐ¿ÑÑÑÑ Ð²ÑÐµÐ¼Ñ
  const isAdmin = isUserHaveRole(ROLE_ADMIN);
  const [clearConfirm, setClearConfirm] = useState(false);
  const [clearing, setClearing] = useState(false);

  useEffect(() => {
    if (!clearConfirm) return undefined;
    const timer = setTimeout(() => setClearConfirm(false), 5000);
    return () => clearTimeout(timer);
  }, [clearConfirm]);

  const handleClearStock = async () => {
    if (!clearConfirm) {
      setClearConfirm(true);
      return;
    }
    setClearing(true);
    try {
      const res = await clearStock();
      alert.success(`Ð¡ÑÐ¾Ðº Ð¾ÑÐ¸ÑÐµÐ½: ÑÐ½ÑÑÐ¾ Ñ Ð¿ÑÐ±Ð»Ð¸ÐºÐ°ÑÐ¸Ð¸ Ð¼Ð°ÑÐ¸Ð½ â ${res?.data?.cleared ?? 0}`);
      setResult(null);
    } catch (err) {
      alert.error(err?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¸ÑÑÐºÐµ ÑÑÐ¾ÐºÐ°. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÐµ ÑÐ°Ð·.');
    } finally {
      setClearing(false);
      setClearConfirm(false);
    }
  };

  const validateFile = useCallback((selectedFile) => {
    const ext = getFileExtension(selectedFile.name);
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
      setValidationError(
        `Ð¤Ð°Ð¹Ð» Â«${selectedFile.name}Â»: Ð½ÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ. ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ ÑÐ°Ð¹Ð» Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ .xlsx Ð¸Ð»Ð¸ .xls`
      );
      return false;
    }

    if (!isFileSizeSmallerThan(selectedFile, MAX_FILE_SIZE_MB)) {
      setValidationError(
        `Ð¤Ð°Ð¹Ð» Â«${selectedFile.name}Â» Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ ÑÐ°Ð·Ð¼ÐµÑ (${MAX_FILE_SIZE_MB} ÐÐ)`
      );
      return false;
    }

    return true;
  }, []);

  const handleFiles = useCallback(
    (selectedFiles) => {
      setValidationError('');
      setResult(null);

      const incoming = Array.from(selectedFiles || []);
      if (incoming.length === 0) return;

      const valid = incoming.filter(validateFile);
      if (valid.length === 0) return;

      setFiles((prev) => {
        // ÐÐµÐ´ÑÐ¿ Ð¿Ð¾ Ð¸Ð¼ÐµÐ½Ð¸+ÑÐ°Ð·Ð¼ÐµÑÑ: Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ Ð¶Ðµ ÑÐ°Ð¹Ð» Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐ»ÑÑÐ°Ð¹Ð½Ð¾ Ð¿ÐµÑÐµÑÐ°ÑÐ¸ÑÑ
        // Ð´Ð²Ð°Ð¶Ð´Ñ â Ð³ÑÑÐ·Ð¸ÑÑ ÐµÐ³Ð¾ Ð² Ð¿Ð°ÑÐºÐµ Ð´Ð²Ð° ÑÐ°Ð·Ð° Ð±ÐµÑÑÐ¼ÑÑÐ»ÐµÐ½Ð½Ð¾ (Ð´ÑÐ±Ð»Ð¸ VIN ÑÐ¹Ð´ÑÑ
        // Ð² Ð¾ÑÐ¸Ð±ÐºÐ¸)
        const seen = new Set(prev.map((f) => `${f.name}|${f.size}`));
        const merged = [...prev];
        valid.forEach((f) => {
          const key = `${f.name}|${f.size}`;
          if (!seen.has(key)) {
            seen.add(key);
            merged.push(f);
          }
        });
        if (merged.length > MAX_FILES) {
          setValidationError(`ÐÐ¾Ð¶Ð½Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð½Ðµ Ð±Ð¾Ð»ÐµÐµ ${MAX_FILES} ÑÐ°Ð¹Ð»Ð¾Ð² Ð·Ð° ÑÐ°Ð·`);
          return merged.slice(0, MAX_FILES);
        }
        return merged;
      });
    },
    [validateFile]
  );

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);

      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        handleFiles(e.dataTransfer.files);
      }
    },
    [handleFiles]
  );

  const handleInputChange = useCallback(
    (e) => {
      if (e.target.files && e.target.files.length > 0) {
        handleFiles(e.target.files);
      }
      // Ð¡Ð±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼ input, ÑÑÐ¾Ð±Ñ ÑÐ´Ð°Ð»ÑÐ½Ð½ÑÐ¹ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ° ÑÐ°Ð¹Ð» Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ ÑÐ½Ð¾Ð²Ð°
      e.target.value = '';
    },
    [handleFiles]
  );

  const handleBrowseClick = () => {
    inputRef.current?.click();
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setValidationError('');
  };

  const handleClearFiles = () => {
    setFiles([]);
    setValidationError('');
    setResult(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const handleUpload = async () => {
    if (files.length === 0) return;

    setUploading(true);
    setValidationError('');
    setResult(null);

    try {
      const response = await uploadStock(files);
      const data = response.data;

      if (data.success) {
        setResult({
          type: 'success',
          totalRows: data.totalRows,
          imported: data.imported,
          files: data.files || [],
        });
        alert.success('Ð¡ÑÐ¾Ðº Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½');
        setFiles([]);
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      } else {
        setResult({
          type: 'error',
          totalRows: data.totalRows,
          imported: data.imported,
          errors: data.errors || [],
          files: data.files || [],
          sessionId: data.sessionId || null,
          pendingRows: data.pendingRows || [],
        });
        alert.error('ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð° Ñ Ð¾ÑÐ¸Ð±ÐºÐ°Ð¼Ð¸');
        setFiles([]);
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      }
    } catch (err) {
      const message =
        err?.response?.data?.errorMessage ||
        err?.response?.data?.message ||
        'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐµ ÑÐ°Ð¹Ð»Ð°. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÐµ ÑÐ°Ð·.';
      setResult({
        type: 'error',
        totalRows: 0,
        imported: 0,
        errors: [{ row: 'â', message }],
        files: [],
      });
      alert.error(message);
      setFiles([]);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    } finally {
      setUploading(false);
    }
  };

  // ÐÐ¼Ð¿Ð¾ÑÑ Ð¸Ð· ÐÐ¸ÑÑÐ¸ÐºÑÐ° Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ ÑÐ¾Ñ Ð¶Ðµ StockImportResult, ÑÑÐ¾ Ð¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐ° ÑÐ°Ð¹Ð»Ð¾Ð²,
  // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð´Ð°Ð»ÑÑÐµ Ð²ÑÑ ÑÐ¸ÑÑÐµÑÑÑ ÑÐµÐ¼Ð¸ Ð¶Ðµ ÐºÐ°ÑÑÐ¾ÑÐºÐ°Ð¼Ð¸ Ð¸ ÑÐ¾Ð¹ Ð¶Ðµ ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹ Ð¿ÑÐ°Ð²ÐºÐ¸
  const handleBitrixResult = (data) => {
    if (!data) return;
    setResult({
      type: data.success ? 'success' : 'error',
      totalRows: data.totalRows,
      imported: data.imported,
      errors: data.errors || [],
      files: data.files || [],
      sessionId: data.sessionId || null,
      pendingRows: data.pendingRows || [],
    });
  };

  const handleSourceChange = (next) => {
    setSource(next);
    setResult(null);
    setValidationError('');
  };

  const handlePendingRowsResolved = (data) => {
    setResult((prev) => {
      if (!prev) return prev;
      const pendingRows = data.pendingRows || [];
      // errors/type Ð´Ð¾Ð»Ð¶Ð½Ñ Ð¾ÑÑÐ°Ð¶Ð°ÑÑ Ð¢ÐÐÐ£Ð©ÐÐ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ (ÑÑÐ¾ ÑÐµÐ°Ð»ÑÐ½Ð¾ ÐµÑÑ Ð½Ðµ
      // ÑÐµÑÐµÐ½Ð¾), Ð° Ð½Ðµ Ð·Ð°ÑÑÑÐ²ÑÐ¸Ð¹ ÑÐ½Ð¸Ð¼Ð¾Ðº Ð¸Ð· ÑÐ°Ð¼Ð¾Ð¹ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ â Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾ÑÐ»Ðµ
      // ÑÐ¾Ð³Ð¾ ÐºÐ°Ðº Ð²ÑÐµ ÑÑÑÐ¾ÐºÐ¸ Ð¿Ð¾Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ð¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ, ÑÑÑ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°Ð» Ð±Ñ
      // Ð²Ð¸ÑÐµÑÑ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¾ÑÐ¸Ð±Ð¾Ðº Ð¸ ÐºÑÐ°ÑÐ½ÑÐ¹ Ð±Ð°Ð½Ð½ÐµÑ "Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¾ Ñ Ð¾ÑÐ¸Ð±ÐºÐ°Ð¼Ð¸",
      // ÑÐ¾ÑÑ Ð½Ð° Ð´ÐµÐ»Ðµ Ð²ÑÑ ÑÐ¶Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾ (ÑÐ¼. imported === totalRows)
      const errors = pendingRows.map((r) => ({
        row: r.row,
        fileName: r.fileName,
        message: r.errors?.[0] || 'Ð¢ÑÐµÐ±ÑÐµÑÑÑ ÑÑÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°',
      }));
      return {
        ...prev,
        imported: prev.imported + (data.imported || 0),
        sessionId: data.sessionId || null,
        pendingRows,
        errors,
        type: pendingRows.length > 0 ? 'error' : 'success',
      };
    });
  };

  return (
    <>
      <Header title="ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÑÐ¾ÐºÐ°" icon={icon} />
      <div className={styles.container}>
        {uploading && (
          <div className={styles.overlay}>
            <div className={styles.overlaySpinner} />
            <div className={styles.overlayText}>ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÐ°Ð¹Ð»Ð¾Ð²...</div>
          </div>
        )}

        <div className={styles.sourceTabs}>
          <button
            type="button"
            className={`${styles.sourceTab} ${source === 'file' ? styles.sourceTabActive : ''}`}
            onClick={() => handleSourceChange('file')}
            disabled={uploading}
          >
            Ð¤Ð°Ð¹Ð»Ñ Excel
          </button>
          <button
            type="button"
            className={`${styles.sourceTab} ${source === 'bitrix' ? styles.sourceTabActive : ''}`}
            onClick={() => handleSourceChange('bitrix')}
            disabled={uploading}
          >
            ÐÐ¸ÑÑÐ¸ÐºÑ
          </button>
        </div>

        {source === 'bitrix' && <BitrixImportPanel onResult={handleBitrixResult} />}

        {source === 'file' && (
          <>
        <div
          className={`${styles.dropZone} ${dragActive ? styles.dropZoneActive : ''}`}
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
          onClick={handleBrowseClick}
        >
          <div className={styles.dropZoneIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
            </svg>
          </div>
          <div className={styles.dropZoneTitle}>
            ÐÐµÑÐµÑÐ°ÑÐ¸ÑÐµ ÑÐ°Ð¹Ð»Ñ ÑÑÐ´Ð° Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ Ð´Ð»Ñ Ð²ÑÐ±Ð¾ÑÐ°
          </div>
          <div className={styles.dropZoneSubtitle}>
            ÐÐ¾Ð´Ð´ÐµÑÐ¶Ð¸Ð²Ð°ÐµÐ¼ÑÐµ ÑÐ¾ÑÐ¼Ð°ÑÑ: .xlsx, .xls. ÐÐ¾Ð¶Ð½Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð¹Ð»Ð¾Ð² â Ð¾Ð½Ð¸
            Ð±ÑÐ´ÑÑ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐ°Ð½Ñ ÐºÐ°Ðº Ð¾Ð´Ð½Ð° Ð·Ð°Ð³ÑÑÐ·ÐºÐ°
          </div>
          <div className={styles.dropZoneHint}>
            ÐÐ¾ {MAX_FILES} ÑÐ°Ð¹Ð»Ð¾Ð², Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ ÑÐ°Ð·Ð¼ÐµÑ ÑÐ°Ð¹Ð»Ð°: {MAX_FILE_SIZE_MB} ÐÐ
          </div>
        </div>

        <input
          ref={inputRef}
          type="file"
          accept=".xlsx,.xls"
          multiple
          className={styles.fileInput}
          onChange={handleInputChange}
        />

        {files.length > 0 && (
          <div className={styles.fileList}>
            {files.map((file, index) => (
              <div key={`${file.name}|${file.size}`} className={styles.fileInfo}>
                <div className={styles.fileInfoIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
                  </svg>
                </div>
                <div className={styles.fileInfoDetails}>
                  <div className={styles.fileName}>{file.name}</div>
                  <div className={styles.fileSize}>{formatFileSize(file.size)}</div>
                </div>
                <button
                  type="button"
                  className={styles.fileRemove}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveFile(index);
                  }}
                  disabled={uploading}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}

        <div className={styles.actions}>
          <Button
            fill
            text={files.length > 1 ? `ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ (${files.length})` : 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ'}
            onClick={handleUpload}
            disabled={files.length === 0 || uploading}
          />
          {files.length > 0 && !uploading && (
            <Button text="ÐÑÐ¼ÐµÐ½Ð°" onClick={handleClearFiles} />
          )}
          {isAdmin && (
            <Button
              text={clearing ? 'ÐÑÐ¸ÑÑÐºÐ°â¦' : clearConfirm ? 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¾ÑÐ¸ÑÑÐºÑ ÑÑÐ¾ÐºÐ°?' : 'ÐÑÐ¸ÑÑÐ¸ÑÑ ÑÑÐ¾Ðº'}
              onClick={handleClearStock}
              disabled={uploading || clearing}
              style={clearConfirm ? { backgroundColor: '#d9534f', color: '#fff', borderColor: '#d9534f' } : {}}
            />
          )}
        </div>

        {validationError && <div className={styles.error}>{validationError}</div>}
          </>
        )}

        {result && result.type === 'success' && (
          <div className={styles.resultCard}>
            <div className={styles.resultHeaderSuccess}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9.003 14L4.76 9.757L6.174 8.343L9.003 11.172L14.659 5.515L16.074 6.929L9.003 14Z"
                  fill="#5cb85c"
                />
              </svg>
              <span>ÐÐ¼Ð¿Ð¾ÑÑ Ð·Ð°Ð²ÐµÑÑÐµÐ½ ÑÑÐ¿ÐµÑÐ½Ð¾</span>
            </div>
            <div className={styles.resultStats}>
              <div className={styles.resultStat}>
                <span className={styles.resultStatLabel}>ÐÑÐµÐ³Ð¾ ÑÑÑÐ¾Ðº:</span>
                <span className={styles.resultStatValue}>{result.totalRows}</span>
              </div>
              <div className={styles.resultStat}>
                <span className={styles.resultStatLabel}>ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾:</span>
                <span className={styles.resultStatValue + ' ' + styles.resultStatSuccess}>{result.imported}</span>
              </div>
              {result.imported > 0 && (
                <div className={styles.resultStat}>
                  <span className={styles.resultStatLabel}>Ð¦ÐµÐ½Ð° Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ:</span>
                  <span className={styles.resultStatValue}>{result.pricedByOrder ?? 0}</span>
                </div>
              )}
              {result.noPrice > 0 && (
                <div className={styles.resultStat}>
                  <span className={styles.resultStatLabel}>ÐÐµÐ· ÑÐµÐ½Ñ:</span>
                  <span className={styles.resultStatValue}>{result.noPrice}</span>
                </div>
              )}
            </div>
            {/* ÐÐ°ÑÐ¸Ð½Ñ Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð¸ ÑÐ¶Ðµ Ð²Ð¸Ð´Ð½Ñ Ð²
                Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ â ÑÑÐ¾ ÑÐ¾Ð²Ð½Ð¾ ÑÐ° ÐºÑÐ¸Ð²Ð°Ñ ÑÐµÐ½Ð°, ÑÐ°Ð´Ð¸ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð·Ð°Ð²Ð¾Ð´Ð¸Ð»ÑÑ Ð¿ÑÐ°Ð¹Ñ.
                ÐÐ¾Ð»ÑÐ°ÑÑ Ð¾ Ð½ÐµÐ¹ Ð½ÐµÐ»ÑÐ·Ñ: Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð° Ð²ÑÐ¿Ð»ÑÐ²ÑÑ, ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ ÐºÑÐ¾-ÑÐ¾ ÑÐ°Ð¼
                Ð·Ð°Ð³Ð»ÑÐ½ÐµÑ Ð² ÑÐºÑÐ°Ð½ Ð¿ÑÐ°Ð¹ÑÐ° */}
            {result.noPriceRule > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noPriceRule} Ð¼Ð°ÑÐ¸Ð½ Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° â Ð¿Ð¾Ð´ Ð½Ð¸Ñ Ð½ÐµÑ
                Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð² Ð¿ÑÐ°Ð¹ÑÐµ.{' '}
                <button type="button" onClick={() => navigate('/price-list')}>
                  ÐÑÐºÑÑÑÑ Ð¿ÑÐ°Ð¹Ñ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ
                </button>
              </div>
            )}
            {/* Ð Ð°Ð½ÑÑÐµ ÑÐ°ÐºÐ°Ñ ÑÑÑÐ¾ÐºÐ° Ð¾ÑÐºÐ»Ð¾Ð½ÑÐ»Ð°ÑÑ Ð¸ Ð²Ð¸ÑÐµÐ»Ð° Ð² ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ°Ð²ÐºÐµ, Ð³Ð´Ðµ
                Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð±ÑÐ»Ð¾ Ð½ÐµÑÐµÐ³Ð¾ Ð²Ð²ÐµÑÑÐ¸: ÑÐµÐ½Ñ Ð½ÐµÑ Ð½Ð¸ Ð² ÑÐ°Ð¹Ð»Ðµ, Ð½Ð¸ Ñ Ð½ÐµÐ³Ð¾. Ð¢ÐµÐ¿ÐµÑÑ
                Ð¼Ð°ÑÐ¸Ð½Ð° Ð² ÑÑÐ¾ÐºÐµ, Ð½Ð¾ Ñ Ð½ÑÐ»ÑÐ¼ â Ð¸ Ð¾Ð± ÑÑÐ¾Ð¼ Ð½Ð°Ð´Ð¾ ÑÐºÐ°Ð·Ð°ÑÑ Ð³ÑÐ¾Ð¼ÑÐµ, ÑÐµÐ¼ Ð¿ÑÐ¾
                ÑÐµÐ½Ñ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ°: Ð½Ð¾Ð»Ñ Ð²Ð¸Ð´ÐµÐ½ ÐºÐ»Ð¸ÐµÐ½ÑÑ */}
            {result.noPrice > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noPrice} Ð¼Ð°ÑÐ¸Ð½ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ Ð±ÐµÐ· ÑÐµÐ½Ñ â ÐµÑ Ð½ÐµÑ Ð½Ð¸ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ, Ð½Ð¸ Ð²
                Ð¿ÑÐ°Ð¹ÑÐµ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ. Ð ÑÑÐ¾ÐºÐµ Ð¾Ð½Ð¸ ÑÑÐ¾ÑÑ 0 â¸, Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾.{' '}
                <button type="button" onClick={() => navigate('/price-list')}>
                  ÐÐ°Ð²ÐµÑÑÐ¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð² Ð¿ÑÐ°Ð¹ÑÐµ
                </button>
              </div>
            )}
            {/* ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ Ð½Ðµ Ð¿ÑÐ¸ÑÑÐ» Ð½Ð¸ Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸, Ð½Ð¸ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸. ÐÐ°Ð½ÐºÐ¸ Ð¸ÑÑÑ
                Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¿Ð¾ Ð¾Ð±ÑÑÐ¼Ñ, Ð¸ Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ ÑÐ°ÐºÐ¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ Ð½Ðµ ÑÐ¹Ð´ÑÑ â Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ·Ð½Ð°Ð» Ð±Ñ
                Ð¾Ð± ÑÑÐ¾Ð¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ, ÑÐ¶Ðµ Ð½Ð° ÑÐ´ÐµÐ»ÐºÐµ */}
            {result.noEngineVolume > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noEngineVolume} Ð¼Ð°ÑÐ¸Ð½ Ð±ÐµÐ· Ð¾Ð±ÑÑÐ¼Ð° Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ â Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ Ð½Ð¸Ð¼ Ð½Ðµ ÑÐ¹Ð´ÑÑ
                Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð¾Ð±ÑÑÐ¼ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¼Ð°ÑÐ¸Ð½Ñ (Ð² ÑÐ¼Â³, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 1499).
              </div>
            )}
            {result.files?.length > 1 && (
              <div className={styles.fileStats}>
                {result.files.map((f, idx) => (
                  <div key={idx} className={styles.fileStatRow}>
                    <span className={styles.fileStatName}>{f.fileName}</span>
                    <span className={styles.fileStatNumbers}>
                      ÑÑÑÐ¾Ðº: {f.totalRows} Â· Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾: {f.imported} Â· Ð¾ÑÐ¸Ð±Ð¾Ðº: {f.errorCount}
                      {f.noPriceRule > 0 && ` Â· Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð°: ${f.noPriceRule}`}
                      {f.noPrice > 0 && ` Â· Ð±ÐµÐ· ÑÐµÐ½Ñ: ${f.noPrice}`}
                      {f.noEngineVolume > 0 && ` Â· Ð±ÐµÐ· Ð¾Ð±ÑÑÐ¼Ð°: ${f.noEngineVolume}`}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {result && result.type === 'error' && (
          <div className={styles.resultCard}>
            <div className={styles.resultHeaderError}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM9 5H11V11H9V5Z"
                  fill="#d9534f"
                />
              </svg>
              <span>ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð° Ñ Ð¾ÑÐ¸Ð±ÐºÐ°Ð¼Ð¸</span>
            </div>
            <div className={styles.resultStats}>
              <div className={styles.resultStat}>
                <span className={styles.resultStatLabel}>ÐÑÐµÐ³Ð¾ ÑÑÑÐ¾Ðº:</span>
                <span className={styles.resultStatValue}>{result.totalRows}</span>
              </div>
              <div className={styles.resultStat}>
                <span className={styles.resultStatLabel}>ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾:</span>
                <span className={styles.resultStatValue + ' ' + styles.resultStatSuccess}>{result.imported}</span>
              </div>
              {result.imported > 0 && (
                <div className={styles.resultStat}>
                  <span className={styles.resultStatLabel}>Ð¦ÐµÐ½Ð° Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ:</span>
                  <span className={styles.resultStatValue}>{result.pricedByOrder ?? 0}</span>
                </div>
              )}
              {result.noPrice > 0 && (
                <div className={styles.resultStat}>
                  <span className={styles.resultStatLabel}>ÐÐµÐ· ÑÐµÐ½Ñ:</span>
                  <span className={styles.resultStatValue}>{result.noPrice}</span>
                </div>
              )}
              <div className={styles.resultStat}>
                <span className={styles.resultStatLabel}>ÐÑÐ¸Ð±Ð¾Ðº:</span>
                <span className={styles.resultStatValue + ' ' + styles.resultStatError}>{result.errors.length}</span>
              </div>
            </div>
            {/* ÐÐ°ÑÐ¸Ð½Ñ Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð¸ ÑÐ¶Ðµ Ð²Ð¸Ð´Ð½Ñ Ð²
                Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ â ÑÑÐ¾ ÑÐ¾Ð²Ð½Ð¾ ÑÐ° ÐºÑÐ¸Ð²Ð°Ñ ÑÐµÐ½Ð°, ÑÐ°Ð´Ð¸ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð·Ð°Ð²Ð¾Ð´Ð¸Ð»ÑÑ Ð¿ÑÐ°Ð¹Ñ.
                ÐÐ¾Ð»ÑÐ°ÑÑ Ð¾ Ð½ÐµÐ¹ Ð½ÐµÐ»ÑÐ·Ñ: Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð° Ð²ÑÐ¿Ð»ÑÐ²ÑÑ, ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ ÐºÑÐ¾-ÑÐ¾ ÑÐ°Ð¼
                Ð·Ð°Ð³Ð»ÑÐ½ÐµÑ Ð² ÑÐºÑÐ°Ð½ Ð¿ÑÐ°Ð¹ÑÐ° */}
            {result.noPriceRule > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noPriceRule} Ð¼Ð°ÑÐ¸Ð½ Ð¿ÑÐ¸ÐµÑÐ°Ð»Ð¸ Ñ ÑÐµÐ½Ð¾Ð¹ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° â Ð¿Ð¾Ð´ Ð½Ð¸Ñ Ð½ÐµÑ
                Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð² Ð¿ÑÐ°Ð¹ÑÐµ.{' '}
                <button type="button" onClick={() => navigate('/price-list')}>
                  ÐÑÐºÑÑÑÑ Ð¿ÑÐ°Ð¹Ñ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ
                </button>
              </div>
            )}
            {/* Ð Ð°Ð½ÑÑÐµ ÑÐ°ÐºÐ°Ñ ÑÑÑÐ¾ÐºÐ° Ð¾ÑÐºÐ»Ð¾Ð½ÑÐ»Ð°ÑÑ Ð¸ Ð²Ð¸ÑÐµÐ»Ð° Ð² ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ°Ð²ÐºÐµ, Ð³Ð´Ðµ
                Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð±ÑÐ»Ð¾ Ð½ÐµÑÐµÐ³Ð¾ Ð²Ð²ÐµÑÑÐ¸: ÑÐµÐ½Ñ Ð½ÐµÑ Ð½Ð¸ Ð² ÑÐ°Ð¹Ð»Ðµ, Ð½Ð¸ Ñ Ð½ÐµÐ³Ð¾. Ð¢ÐµÐ¿ÐµÑÑ
                Ð¼Ð°ÑÐ¸Ð½Ð° Ð² ÑÑÐ¾ÐºÐµ, Ð½Ð¾ Ñ Ð½ÑÐ»ÑÐ¼ â Ð¸ Ð¾Ð± ÑÑÐ¾Ð¼ Ð½Ð°Ð´Ð¾ ÑÐºÐ°Ð·Ð°ÑÑ Ð³ÑÐ¾Ð¼ÑÐµ, ÑÐµÐ¼ Ð¿ÑÐ¾
                ÑÐµÐ½Ñ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ°: Ð½Ð¾Ð»Ñ Ð²Ð¸Ð´ÐµÐ½ ÐºÐ»Ð¸ÐµÐ½ÑÑ */}
            {result.noPrice > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noPrice} Ð¼Ð°ÑÐ¸Ð½ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ Ð±ÐµÐ· ÑÐµÐ½Ñ â ÐµÑ Ð½ÐµÑ Ð½Ð¸ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ, Ð½Ð¸ Ð²
                Ð¿ÑÐ°Ð¹ÑÐµ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ. Ð ÑÑÐ¾ÐºÐµ Ð¾Ð½Ð¸ ÑÑÐ¾ÑÑ 0 â¸, Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾.{' '}
                <button type="button" onClick={() => navigate('/price-list')}>
                  ÐÐ°Ð²ÐµÑÑÐ¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð² Ð¿ÑÐ°Ð¹ÑÐµ
                </button>
              </div>
            )}
            {/* ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ Ð½Ðµ Ð¿ÑÐ¸ÑÑÐ» Ð½Ð¸ Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸, Ð½Ð¸ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸. ÐÐ°Ð½ÐºÐ¸ Ð¸ÑÑÑ
                Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¿Ð¾ Ð¾Ð±ÑÑÐ¼Ñ, Ð¸ Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ ÑÐ°ÐºÐ¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ Ð½Ðµ ÑÐ¹Ð´ÑÑ â Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ·Ð½Ð°Ð» Ð±Ñ
                Ð¾Ð± ÑÑÐ¾Ð¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ, ÑÐ¶Ðµ Ð½Ð° ÑÐ´ÐµÐ»ÐºÐµ */}
            {result.noEngineVolume > 0 && (
              <div className={styles.noRuleNotice}>
                {result.noEngineVolume} Ð¼Ð°ÑÐ¸Ð½ Ð±ÐµÐ· Ð¾Ð±ÑÑÐ¼Ð° Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ â Ð·Ð°ÑÐ²ÐºÐ° Ð¿Ð¾ Ð½Ð¸Ð¼ Ð½Ðµ ÑÐ¹Ð´ÑÑ
                Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð¾Ð±ÑÑÐ¼ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¼Ð°ÑÐ¸Ð½Ñ (Ð² ÑÐ¼Â³, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 1499).
              </div>
            )}
            {result.files?.length > 1 && (
              <div className={styles.fileStats}>
                {result.files.map((f, idx) => (
                  <div key={idx} className={styles.fileStatRow}>
                    <span className={styles.fileStatName}>{f.fileName}</span>
                    <span className={styles.fileStatNumbers}>
                      ÑÑÑÐ¾Ðº: {f.totalRows} Â· Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾: {f.imported} Â· Ð¾ÑÐ¸Ð±Ð¾Ðº: {f.errorCount}
                      {f.noPriceRule > 0 && ` Â· Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð°: ${f.noPriceRule}`}
                      {f.noPrice > 0 && ` Â· Ð±ÐµÐ· ÑÐµÐ½Ñ: ${f.noPrice}`}
                      {f.noEngineVolume > 0 && ` Â· Ð±ÐµÐ· Ð¾Ð±ÑÑÐ¼Ð°: ${f.noEngineVolume}`}
                    </span>
                  </div>
                ))}
              </div>
            )}
            {/* ÐÐ¾Ð³Ð´Ð° ÐµÑÑÑ ÑÐµÑÑÐ¸Ñ Ð¿ÑÐ°Ð²ÐºÐ¸ â ÑÐµ Ð¶Ðµ Ð¾ÑÐ¸Ð±ÐºÐ¸ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ñ Ð¿Ð¾ ÑÑÑÐ¾ÐºÐ°Ð¼ Ð½Ð¸Ð¶Ðµ
                (ÐºÐ¾Ð¼Ð¿Ð°ÐºÑÐ½ÑÐ¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ Â«Ð±ÐµÐ· Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸ÑÂ» Ð¸ ÑÐ¾ÑÐ¼Ð°Ð¼Ð¸ Ð´Ð»Ñ ÑÐµÐ°Ð»ÑÐ½ÑÑ
                Ð¾ÑÐ¸Ð±Ð¾Ðº), Ð¿Ð»Ð¾ÑÐºÐ¸Ð¹ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð´ÑÐ±Ð»Ð¸ÑÑÐµÑ Ð¸ ÑÐ°Ð·Ð´ÑÐ²Ð°ÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ
                Ð½Ð° Ð±Ð¾Ð»ÑÑÐ¸Ñ ÑÐ°Ð¹Ð»Ð°Ñ. ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÐµÐ³Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÐ°ÑÐ°Ð»ÑÐ½ÑÑ Ð¾ÑÐ¸Ð±Ð¾Ðº Ð±ÐµÐ·
                ÑÐµÑÑÐ¸Ð¸ (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÑÐ°Ð¹Ð» Ð²Ð¾Ð¾Ð±ÑÐµ Ð½Ðµ ÑÐ°ÑÐ¿Ð°ÑÑÐ¸Ð»ÑÑ) */}
            {result.errors.length > 0 && !result.sessionId && (
              <div className={styles.errorTable}>
                <div className={styles.errorTableHeader}>
                  <span className={styles.errorTableColRow}>Ð¡ÑÑÐ¾ÐºÐ°</span>
                  <span className={styles.errorTableColMsg}>ÐÑÐ¸Ð±ÐºÐ°</span>
                </div>
                {result.errors.map((err, idx) => (
                  <div key={idx} className={styles.errorTableRow}>
                    {/* row = 0 Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº ÑÑÐ¾Ð²Ð½Ñ Ð¸ÑÑÐ¾ÑÐ½Ð¸ÐºÐ° (Ð½ÐµÑÐ¸ÑÐ°ÐµÐ¼ÑÐ¹ ÑÐ°Ð¹Ð», Ð½ÐµÐ¿Ð¾Ð½ÑÑÑÐ¹
                        ÐÐ¦) â Ð½Ð¾Ð¼ÐµÑÐ° ÑÑÑÐ¾ÐºÐ¸ Ñ Ð½Ð¸Ñ Ð½ÐµÑ, Ð¸ Ð¿ÐµÑÐ°ÑÐ°ÑÑ Ð½Ð¾Ð»Ñ Ð½ÐµÐ·Ð°ÑÐµÐ¼ */}
                    <span className={styles.errorTableColRow}>{err.row || 'â'}</span>
                    <span className={styles.errorTableColMsg}>
                      {err.fileName ? `[${err.fileName}] ` : ''}
                      {err.message}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {result?.sessionId && result.pendingRows?.length > 0 && (
          <StockPendingRowsTable
            key={result.sessionId}
            sessionId={result.sessionId}
            pendingRows={result.pendingRows}
            onResolved={handlePendingRowsResolved}
          />
        )}

        {/* ÐÑÑÑÑÑ Ð¿ÑÐ¾ÑÐ»ÑÑ Ð¿ÑÐ¾Ð³Ð¾Ð½Ð¾Ð²: ÑÐ°Ð½ÑÑÐµ ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ Ð¶Ð¸Ð» ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð¾ Ð·Ð°ÐºÑÑÑÐ¸Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ */}
        <StockImportHistory />
      </div>
    </>
  );
};

export default StockUpload;
